import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { BrandMark } from "../components/AppShell";
import { toast } from "sonner";
import { errFrom } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(errFrom(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6">
      <form onSubmit={submit} className="w-full max-w-md brand-surface rounded-2xl p-8 space-y-6" data-testid="forgot-password-form">
        <div className="flex items-center justify-between">
          <BrandMark size={36} />
          <Link to="/login" className="text-zinc-500 hover:text-white flex items-center gap-1 text-sm"><ArrowLeft size={14} />Login</Link>
        </div>
        {sent ? (
          <div>
            <h1 className="font-heading text-3xl font-bold">Check your inbox</h1>
            <p className="text-zinc-400 mt-3">If an account exists for <span className="text-white">{email}</span>, you'll receive a reset link within a few minutes.</p>
          </div>
        ) : (
          <>
            <div>
              <div className="text-overline mb-2">Reset</div>
              <h1 className="font-heading text-3xl font-bold tracking-tight">Forgot your password?</h1>
              <p className="text-zinc-500 text-sm mt-2">Enter your email and we'll send a reset link.</p>
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-[#0A0A0A] border-white/10 h-12" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={loading}
              className="w-full h-12 bg-[#FF3B30] hover:bg-[#E02920] text-white font-semibold" data-testid="forgot-submit-button">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </>
        )}
      </form>
    </div>
  );
}
